<template>
  <button
    v-if="label"
    type="button"
    data-test="announcement-nav-button"
    class="w-full flex items-center gap-2.5 text-left cursor-pointer rounded-md px-3.5 py-3 bg-primary-light border border-primary-lighter text-gray-900 shadow-sm transition-all duration-150 ease-in-out hover:-translate-y-px hover:shadow-md"
    @click="open"
  >
    <span class="h-2 w-2 shrink-0 rounded-full bg-primary-dark motion-safe:animate-pulse" aria-hidden="true"></span>
    <span class="flex flex-col min-w-0">
      <span class="text-[13px] font-extrabold tracking-tight truncate">{{ label.title }}</span>
      <span class="text-[11px] font-semibold text-gray-600 truncate">{{ label.subtitle }}</span>
    </span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

// Sidebar entry reopening the running announcement, even once closed.
export default {
  emits: ["click"],

  computed: {
    ...mapGetters("announcements", { announcement: "navAnnouncement" }),

    label() {
      const navButton = this.announcement?.navButton;
      return navButton ? (navButton[this.$i18n.locale] ?? navButton.fr) : null;
    },
  },

  methods: {
    ...mapActions("announcements", ["reopen"]),

    open() {
      this.reopen(this.announcement.slug);
      this.$emit("click");
    },
  },
};
</script>
